import React, { useEffect, useMemo, useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader, InfoBox } from "@react-google-maps/api";
import { AtendimentosSSEService } from "../../../services/AtendimentosSSEService";
import PinSebrae from './pin-sebrae.svg';
import { cnpjMask, cpfMask } from "../../../../../utils/mask";
import { useLocation } from "react-router-dom";
import { removeEmpty } from "../../../../../utils/utils";

export const VerMapa = (props) => {

    const VISITA_LABEL = {
        PRIMEIRA_VISITA: 1,
        SEGUNDA_VISITA: 2,
    };

    const containerStyle = {
        width: '100%',
        height: '80%',
        margin: '0 auto'
    }

    const infoWindowStyle = {
        background: "white",
        border: "1px solid #ccc",
        padding: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        borderRadius: '4px'
    };

    const location = useLocation();
    const filterData = location?.state?.filters;

    const [data, setData] = useState([]);
    const [markersAttendances, setMarkesAttendances] = useState([]);
    const [markersCompanies, setMarkesCompanies] = useState([]);
    const [mapCenter, setMapCenter] = useState({lat: null, lng: null});
    const [companyInfo, setCompanyInfo] = useState(null);

    const handleLoadData = async () => {
        console.log('filterData', filterData);
        try {
            const body = {
                ufAbbreviation: filterData?.ufs && filterData?.ufs[0]?.sigla,
                agentCpf: '',
                startDate: filterData?.dataInicial,
                endDate: filterData?.dataFinal,
                searchQuery: filterData?.oqueVoceProcura,
                visit: filterData?.visita && VISITA_LABEL[filterData.visita],
                municipalityIbgeCode: filterData?.cidades && filterData?.cidades[0]?.codIBGE,
                legalEntitySize: filterData?.porte && [filterData?.porte?.sigla],
            }
            console.log('body', removeEmpty(body));
            const response = await AtendimentosSSEService.attendanceGeoReport(removeEmpty(body));
            setData(response.attendances);
        } catch (error) {
            console.error('Erro ao carregar marcadores:', error);
        }
    };

    const calculateCenter = (markerData) => {
        let totalLat = 0;
        let totalLng = 0;

        for (const marker of markerData) {
            const [lng, lat] = marker.attendance.coordinates.coordinates;
            totalLat += Number(lat);
            totalLng += Number(lng);
        }

        return {
            lat: totalLat / markerData.length,
            lng: totalLng / markerData.length,
        };
    };

    useEffect(() => {
        const handleDataMarkers = () => {
            const attendancesWithCoordinates = data.filter(a => a.attendance?.coordinates?.coordinates?.length);
            const attendancesWithCompanyCoordinates = data.filter(a => a.legalEntity.coordinates?.coordinates?.length);
            console.log('attendancesWithCoordinates', attendancesWithCoordinates.length)
            console.log('attendancesWithCompanyCoordinates', attendancesWithCompanyCoordinates.length)
            setMarkesAttendances(attendancesWithCoordinates);
            setMarkesCompanies(attendancesWithCompanyCoordinates);
        }
        handleDataMarkers()
    }, [data]);

    useEffect(() => {
        const loadCenter = async () => {
            if (markersAttendances.length) {
                const center = calculateCenter(markersAttendances)
                setMapCenter(center);
            }
        }
        loadCenter()
    }, [markersAttendances]);


    useEffect(() => {
        handleLoadData()
        // eslint-disable-next-line
    }, [location]);


    const handleCompanyMarkerMouseOver = (marker, lat, lng) => {
        const {legalEntity, attendant, attendanceGeoValidation} = marker;
        const body = {
            cnpj: cnpjMask(legalEntity.cnpj),
            tradeName: legalEntity.tradeName ?? legalEntity.corporateName,
            sizeAbbreviature: legalEntity.sizeAbbreviature,
            attendantName: attendant.name,
            attendantCPF: cpfMask(attendant.cpf),
            nearToLegalEntity: attendanceGeoValidation.nearToLegalEntity ? 'Sim' : 'Não',
            lat,
            lng
        }
        setCompanyInfo(body);
    };

    const handleCompanyMarkerMouseOut = () => {
        setCompanyInfo(null);
    };

    const mappedMarkersCompanies = useMemo(() => markersCompanies.map((marker, index) => {
        if(!marker.legalEntity?.coordinates?.coordinates?.length) return null;
        const [lng, lat] = marker.legalEntity.coordinates.coordinates;
        return (
            <Marker
                icon={PinSebrae}
                key={index}
                position={{lat: Number(lat), lng: Number(lng)}}
                onMouseOver={() => handleCompanyMarkerMouseOver(marker, Number(lat), Number(lng))}
                onMouseOut={handleCompanyMarkerMouseOut}
            />
        )
    }), [markersCompanies]);


    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBe5GWIF8Tn_-5THWx1StcfzTIwYEiNwFs"
    })

    return isLoaded && mapCenter ? (
        (!data.length) ? (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '40vh',
            }}>
                <h1>Nenhum registro encontrado para a busca.</h1>
            </div>
        ) : (
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={mapCenter}
                zoom={5}
            >
                {mappedMarkersCompanies}
                {companyInfo && (
                    <InfoBox
                        position={{
                            lat: companyInfo.lat,
                            lng: companyInfo.lng,
                        }}
                        onCloseClick={() => handleCompanyMarkerMouseOut()}
                    >
                        <div style={infoWindowStyle}>
                            <h3>{companyInfo.tradeName}</h3>
                            <p>CNPJ: {companyInfo.cnpj}</p>
                            <p>Porte: {companyInfo.sizeAbbreviature}</p>
                            <p>Atendente: {companyInfo.attendantName}</p>
                            <p>CPF: {companyInfo.attendantCPF}</p>
                            <p>Atendimento realizado próximo a empresa: {companyInfo.nearToLegalEntity}</p>
                        </div>
                    </InfoBox>
                )}
            </GoogleMap>
        )

    ) : <>
    </>
};
